import React from 'react';

const MessageBubble = ({ msg }) => {
    // Highlight {{variables}} in the message
    const renderMessage = (text) => {
        const parts = text.split(/({{[\s\S]+?}})/g);
        return parts.map((part, i) => {
            if (part.match(/^{{[\s\S]+?}}$/)) {
                return (
                    <span key={i} style={{
                        background: '#E8F5E9',
                        color: '#2E7D32',
                        borderRadius: 3,
                        padding: '1px 4px',
                        fontWeight: 600,
                    }}>
                        {part}
                    </span>
                );
            }
            return part;
        });
    };

    return (
        <div>
            <div style={{
                background: '#FAFAFA',
                border: '1px solid #E6E6E6',
                borderRadius: 6,
                padding: '12px 16px',
                fontSize: 13,
                lineHeight: 1.6,
                color: '#263238',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
            }}>
                {renderMessage(msg)}
            </div>
            <div style={{
                fontSize: 11,
                color: '#607D8B',
                marginTop: 4,
            }}>
                {msg.length} characters
            </div>
        </div>
    );
};

export default MessageBubble;
